module.exports = __webpack_public_path__ + "img/arrow.3ef529b2.svg";